import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { delay, exhaustMap, filter, map, mergeMap, switchMap, takeWhile, tap, withLatestFrom } from 'rxjs/operators';
import { JobService, JobStatus } from 'src/app/services/api.services';
import { SnackService } from 'src/app/services/snack.service';
import { catchAppError } from 'src/app/shared/utils';
import { InsightsJobActions, InsightsJobsSelectors } from '.';

@Injectable()
export class InsightsJobsEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackService: SnackService,
    private jobService: JobService) { }


  getJobState$ = createEffect(() => this.actions$.pipe(
    ofType(InsightsJobActions.getState),
    mergeMap(({ id }) => this.jobService.getState(id).pipe(
      map((jobState) => InsightsJobActions.getStateSuccess({ id, job: jobState })),
      catchAppError(error => of(InsightsJobActions.getStateFailure({ id, error })), { showErrorSnack: false })
    )))
  );

  handleGetJobStateResult$ = createEffect(() => this.actions$.pipe(
    ofType(
      InsightsJobActions.getStateSuccess,
      InsightsJobActions.getStateFailure,
    ),
    withLatestFrom(this.store.select(InsightsJobsSelectors.getTrackedJobsById)),
    mergeMap(([action, trackedJobs]) => {
      let { id } = action;
      let trackedJob = trackedJobs[id];

      let getStateFailed =
         (action.type === InsightsJobActions.getStateFailure.type)
      && (trackedJob.maxFailures > 0 && trackedJob.getStateFailures >= trackedJob.maxFailures);

      if (trackedJob.job.status >= JobStatus.Finished || getStateFailed) {
        return of(
          InsightsJobActions.onCompleted({ id, getStateFailed })
        );
      }
      else {
        return of(
          InsightsJobActions.getState({ id: trackedJob.job.jobId })
        ).pipe(delay(trackedJob.pullInterval));
      }
    }))
  );


  startTrackingAfterStarted$ = createEffect(() => this.actions$.pipe(
    ofType(InsightsJobActions.onStarted),
    withLatestFrom(this.store.select(InsightsJobsSelectors.getTrackedJobsById)),
    filter(([{ id }, jobs]) => !jobs[id]),
    map(([{ id, options }]) => InsightsJobActions.startTracking({ id, options })))
  );

  stopTrackingAfterCompletion$ = createEffect(() => this.actions$.pipe(
    ofType(InsightsJobActions.onCompleted),
    map(({ id }) => InsightsJobActions.stopTracking({ id })))
  );


  getJobStateOnStartTracking$ = createEffect(() => this.actions$.pipe(
    ofType(InsightsJobActions.startTracking),
    map(({ id, options }) => InsightsJobActions.getState({ id })))
  );
}
